<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" v-if="client_id>0">
              <div class="select">
                <select v-model="range">
                  <option value="">Select Range</option>
                  <option value="Jerseys">Jerseys</option>
                  <option value="Leisurewear">Leisurewear</option>
                  <option value="Socks">Socks</option>
                  <option value="Shorts">Shorts</option>
                </select>
              </div>
            </div>
      </div>
        <div class="level-right">
        <button @click="resetOrders()" class="level-item button is-warning " v-if="client_id>0">Return to Customer List</button>
      </div>
      </div>
    
    <table class="table is-hoverable is-fullwidth" id="orderstable" v-if="client_id==0">
    	<thead>
    		<tr>
        <th>Csutomer Name</th>
        <th>Account Number</th>
   	 		<th>Contact Name</th>
         <th></th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="clients_loading===true">
          <td colspan="4"><strong>Loading customer list ...</strong></td>
          </tr>
        <tr v-for="row in clients" v-bind:key="row.clientID">
          <td >{{row.clientname}}</td>
          <td>{{row.accountnumber}}</td>
          <td>{{row.contactname}}</td>
         <td>
            <button class="button is-info is-small" @click="viewCustomer(row.clientID)">View</button>

         </td>
          
             
              
			</tr>
    	</tbody>
    </table>

    <table class="table is-hoverable is-fullwidth" id="orderstable" v-if="client_id>0">
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Customer</th>
        <th>Range</th>
          <th>Design Name</th>
          
          <th>Order Date</th>
          <th>&nbsp;</th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="orders_loading===true">
          <td colspan="8"><strong>Loading orders ...</strong></td>
          </tr>
        <tr v-for="order in orders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.range}}</td>
           <td>{{order.designname}}</td>
          
          <td>{{order.orderdate}}</td>
          <td>
            <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
          </td>
          
             
              
			</tr>
    	</tbody>
    </table>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import SalesService from '@/services/SalesService.js';

export default {
  name:'CustomerOrders',
  components: {
   	
  },
  data() {
    return {
      client_id: 0,
       clients: [],
      orders: [],
      
      
      selectedOrderID: 0,
     accessToken: '',
     clients_loading:true,
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: ''
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getMyCustomers()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
   viewCustomer(client_id)
   {
      this.client_id = client_id;

      this.getOrders()
      
   },
   resetOrders() {
      
      this.client_id=0
      this.orders = [];
   },
    async getOrders() {
      this.orders_loading=true;
      OrderService.getOrders(this.accessToken, this.client_id, this.range)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    async getMyCustomers() {
      this.clients_loading=true;
        SalesService.getUserClients(this.accessToken)
        .then(
            (clients => {
            this.$set(this, "clients", clients);
            this.clients_loading=false;
            }).bind(this)
        );
    },
    
   
  },
  computed : {
     checkedOrders: function () {
        let checkedOrders = []
        checkedOrders = this.orders.filter(row => row.checked === true)
       return checkedOrders
     } 

  },

 
  mounted() {
    
  },
  watch: {
    range: function () {
      this.getOrders()
    },
  }
}



</script>


